import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../types';

const selectAuth = (state: RootState) => state.common.auth;

export const authSelector = createSelector(selectAuth, (state) => state);
export const pinStatusSelector = createSelector(selectAuth, (state) => state.sendPinStatus);
export const enterStatusSelector = createSelector(selectAuth, (state) => state.enterStatus);
export const userInfoSelector = createSelector(selectAuth, (state) => state.data);
export const passengersSelector = createSelector(userInfoSelector, (state) => {
  if (state?.auth) {
    return state.passengers;
  } else {
    return [];
  }
});
